import script from "./expensecategory.vue?vue&type=script&setup=true&lang=js"
export * from "./expensecategory.vue?vue&type=script&setup=true&lang=js"

import "./expensecategory.vue?vue&type=style&index=0&id=c864ccac&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c864ccac"]])

export default __exports__